import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const temperatureCardStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            padding: "20px 20px 20px 10px",
            margin: "50px 0px 0px 0px",
            display: "flex",
        },
        paper: {
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            padding: "20px",
            borderRadius: "0px",
            marginTop: "50px",
            marginLeft: "40px",
        },

        type: {
            lineHeight: "12px",
            color: "rgba(82, 82, 82, 1)",
        },
        plain: {
            fontSize: "16px",
            color: "rgba(153, 153, 153, 1)",
        },
        hours: {
            fontSize: "30px",
            lineHeight: "41px",
            color: "rgba(24, 24, 24, 1)",
        },
        temp: { color: "rgba(24, 24, 24, 1)", lineHeight: "16.8px" },
        collapse: {
            color: "rgba(39, 10, 220, 1)",
            lineHeight: "16.8px",
            cursor: "pointer",
            marginTop: "10px",
        },
    })
);
